import { Component } from '@poa/core';
import React from 'react';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { isEqual, isString } from 'lodash';


export class MultiSelectInput extends React.Component {
  static defaultProps = { clearable: true, isSearchable: true };
  state = { data: [], current: this.props.current || [], loading: true };

  componentDidMount() {
    if (this.props.options && this.props.types[0] === 'levels') {
      this.mapResponseToState(this.props.options);
      return;
    }

    if (this.props.types) {
      Promise.all(
        this.props.types.map(type => this.env.http.get(type).then(response => response.data))
      ).then(data => {
        const items = new Map();

        [].concat(...data).forEach(item => {
          if (!items.has(item.id)) {
            if (isString(item)) {
              items.set(item, item);
            } else {
              items.set(item.id, item);
            }
          }
        });
        this.mapResponseToState([...items.values()]);
      });
      return;
    }

    this.env.http.get(this.props.type).then(response => {
      this.mapResponseToState(response.data);
    });
  }

  componentDidUpdate() {
    let newCurrent = this.props.current.map(item => (this.getLabelFromItem(item)));

    if (!isEqual(newCurrent, this.state.current)) {
      this.setState({ current: newCurrent });
    }
  }

  refreshData() {
    if (this.props.options) {
      this.mapResponseToState(this.props.options);
      return;
    }

    this.env.http.get(this.props.type).then(response => {
      this.mapResponseToState(response.data);
    });
  }

  updateLeadOptions = (inputValue) => {
    if (this.props.types) {
      Promise.all(
        this.props.types.map(type => this.env.http.get(
          type, { params: { Name: inputValue } }
          ).then(response => response.data))
      ).then(data => {
        const items = new Map();

        [].concat(...data).forEach(item => {
          if (!items.has(item.id)) {
            if (isString(item)) {
              items.set(item, item);
            } else {
              items.set(item.id, item);
            }
          }
        });

        this.mapResponseToState([...items.values()]);
      });
    } else if (this.props.type) {
      this.env.http.get(this.props.type, { params: { Name: inputValue } }
        ).then(response => {
        this.mapResponseToState(response.data);
      });
    }
  };

  getLabelFromItem(item) {
    if (isString(item)) {
      return { label: item, value: item };
    }

    if (item.title) {
      return { label: item.title, value: item.title };
    }

    return { label: `${item.last_name} ${item.first_name}`, value: `${item.last_name} ${item.first_name}` };
  }

  getIdFromItem(item) {
    if (item.last_name) {
      return `${item.last_name} ${item.first_name}`;
    }
    return item.title;
  }


  mapResponseToState(response) {
    let loadedData = response.map(item => (this.getLabelFromItem(item)))
    this.setState({data: loadedData, loading: false});
  }
  

  handleChange = selectedOptions => {
    const selectedValues = selectedOptions.map(option => option.value);
    this.setState({ current: selectedOptions });
    this.props.onChange(selectedValues, this.props.name);
  };


  handleInputChange = (inputValue) => {
    if ((this.props.types && (
      this.props.types.includes('scouts') ||
      this.props.types.includes('account-managers') ||
      this.props.types.includes('teamleads') ||
      this.props.types.includes('operators') ||
      this.props.types.includes('managers')
    )) || (['teamleads', 'operators', 'managers', 'scouts', 'account-managers'].includes(this.props.type))) {

      if (inputValue.length >= 2) {
        this.updateLeadOptions(inputValue);
      } else {
        this.setState({ data: [], loading: false});
      }
    }
  };

  render() {
    return (
      <Select
        multi
        onChange={this.handleChange}
        value={this.state.current}
        searchable={this.props.isSearchable}
        isLoading={this.state.loading}
        options={this.state.data}
        clearable={this.props.clearable}
        onInputChange={this.handleInputChange}
      />
    );
  }
}


MultiSelectInput = Component({ namespaces: ['popup'] })(MultiSelectInput);